import Vue from 'vue';
import Vuex from 'vuex';

import Orgs from './modules/Orgs';
import Login from './modules/Login';
import VARs from './modules/VARs';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    Orgs,
    Login,
    VARs,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js